import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {BsGithub} from 'react-icons/bs'
import {SiHackerrank} from 'react-icons/si'

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href="https://www.linkedin.com/in/pratham-kandari-a02ab3235/" target="_blank"><BsLinkedin /></a>
        <a href="https://github.com/prathamkandari" target="_blank"><BsGithub /></a>
        <a href="https://www.hackerrank.com/prathamrushil" target="_blank"><SiHackerrank /></a>
    </div>
  )
}

export default HeaderSocials